module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"unavab":"Offline","online":"Online","back":"Back"},"ru":{"unavab":"Не в сети","online":"В сети","back":"Назад"}}')
  delete Component.options._Ctor
}
